import React from 'react'

const UpdateHistory = () => {
    return (
        <div>
            UpdateHistory
        </div>
    )
}
export default UpdateHistory